export default "__VITE_ASSET__91jyyxvq__";